import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find-index";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/splice";
import { Component } from 'intact-vue-next';
import template from './messages.vdt';
import { useConfigContext } from '../config';
var typeDefs = {
  classNamePrefix: String
};
export var Messages = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Messages, _Component);
  function Messages() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.messages = [];
    _this.config = useConfigContext();
    return _this;
  }
  var _proto = Messages.prototype;
  _proto.notice = function notice(message) {
    this.messages.push(message);
    this.forceUpdate();
  };
  _proto.delete = function _delete(key) {
    var messages = this.messages;
    var index = _findIndexInstanceProperty(messages).call(messages, function (message) {
      return message.key === key;
    });
    if (process.env.NODE_ENV !== 'production' && !~index) {
      throw new Error('You are removing a message that does not exist.');
    }
    _spliceInstanceProperty(messages).call(messages, index, 1);
    this.forceUpdate();
  };
  return Messages;
}(Component);
Messages.template = template;
Messages.typeDefs = typeDefs;